import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { Role, RolesStore } from '@fry/lib/roles';

@Injectable()
export class RoleResolver  {

    constructor(private roles: RolesStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Role> {
        const id = route.paramMap.get('id');
        return this.roles.getForEdit(id);
    }
}
